import React from 'react';

const Quotes = () => (
  <main>
    <div className="qoute flex align-center justify-center">
      <p>
        Mathematics is not about numbers, equations, computations or
        algorithms; it&apos;s about understanding. - William Paul Thurston
      </p>
    </div>
  </main>
);

export default Quotes;
